import { render, staticRenderFns } from "./pinned-message.vue?vue&type=template&id=c349734a&scoped=true"
import script from "./pinned-message.vue?vue&type=script&lang=js"
export * from "./pinned-message.vue?vue&type=script&lang=js"
import style0 from "./pinned-message.vue?vue&type=style&index=0&id=c349734a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c349734a",
  null
  
)

export default component.exports